<template>
  <div class="row text-center mt-0 mb-0">
    <div class="col-md-12">
      <canvas
          id="signature-canvas"
          width="350"
          height="200"
          style="border: 1px solid rgb(208, 208, 208);"
          ref="canvasRef"></canvas>
      <input v-model="formData.digitalSignature" type="hidden"/>
    </div>
  </div>

  <div class="digital-signature-image" v-if="existingDigitalSignature">
    <div class="d-flex flex-row justify-content-center align-items-center">
      <div style="width: 350px; margin-bottom: 20px;">
        <span>Aktuelle Signatur</span>
        <img
            class="img-fluid"
            :src="existingDigitalSignature"
            alt="Signature"
            style="width: 350px; height: 120px; object-fit: contain; border: 1px solid rgb(208, 208, 208);"/>
      </div>
    </div>
  </div>

  <div class="d-flex flex-row justify-content-center align-items-center modal-buttons mt-3">
    <div class="modal_buttons_container">
      <button class="btn btn-primary mr-3" @click="saveSignature"> {{ $t('general.button.save') }}</button>
      <button class="btn btn-danger" @click="clearSignature"> {{ $t('general.button.delete') }}</button>
    </div>
  </div>
</template>

<script setup>
import unemployedService from '@/api/Unemployed';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import SignaturePad from 'signature_pad';
import { defineEmits, defineProps, onMounted, ref, toRefs, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const emit                     = defineEmits([ 'update:modelValue', 'update:submitForm', 'updateDigitalSignature' ]);
const { t }                    = useI18n();
const canvasRef                = ref(null);
const existingDigitalSignature = ref('');
const isLoaded                 = ref(false);
let signaturePad               = null;

const props = defineProps({
  unemployedId: {
    type: [ Number, String ],
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const unemployedId = toRefs(props)[ 'unemployedId' ];

const formData = ref({
  digitalSignature: '',
  unemployedId: +unemployedId.value,
});

async function saveSignature() {
  if (signaturePad && !signaturePad.isEmpty()) {
    emit('updateDigitalSignature', true);
    formData.value.digitalSignature = signaturePad.toDataURL('image/png');
  } else {
    emit('updateDigitalSignature', false);
    formData.value.digitalSignature = ''; // Clear if empty
  }

  try {
    await unemployedService.saveDigitalSignature(formData.value);

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

const clearSignature = () => {
  if (signaturePad) {
    signaturePad.clear();
    formData.value.digitalSignature = '';
  }
};

async function getUnemployedData() {
  try {
    const { data }   = await unemployedService.getUnemployed(unemployedId.value);
    const unemployed = data.data;

    existingDigitalSignature.value = unemployed?.digitalSignatureBase64;
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (canvasRef.value) {
    signaturePad = new SignaturePad(canvasRef.value, {
      backgroundColor: '#fff',
      penColor: 'rgb(0, 0, 0)',
    });
  }

  await getUnemployedData();

  isLoaded.value = true;
});
</script>

<style scoped>
canvas {
  cursor: crosshair;
}

.modal_buttons_container {
  display: flex;
  gap: 165px; /* Adjust the gap as needed */
}
</style>